<template>
  <Page>
    <div class="topimg"></div>
    <div class="con">
      
      <ul class="list">
        <li v-for="(item,index) in list" :key="index" class="fs16">
            <span class="time pc">{{item.created_at}}</span>
            <div class="title ell">
              <span class="mobile">{{item.created_at}}</span>
              <span class="ell">{{item.title}}</span>
            </div>
            <a :href="item.file" target="_blank">{{$t('t1')}}</a>
        </li>
      </ul>

    </div>
  </Page>
</template>

<script>
import Page  from '@/components/page.vue'
import {getGuideList} from '@/api/other.js'


export default {
  name: '',
  i18n:{
    messages:{
      zh:{
        t1:'点击下载',
      },
      en:{
        t1:'Download',
      }
    }
  },
  components:{Page},
  data(){
    return {
      list:[]
    }
  },
  created(){
    getGuideList().then(res=>{
      console.log(res);
      this.list = res;
    })
  },
  methods:{
    changeTab(idx){
      this.tabCheIndex=idx;
    }
  }
}
</script>

<style scoped>
.topimg{width:100%; height:9.42vw; background:url(../../assets/breadcrumb/001.jpg) no-repeat center; background-size:100% 100%;}

.con{padding:4.47vw 5.26vw;}


.list li{display:flex; justify-content: space-between; height:3.68vw; align-items:center; border-bottom:1px solid #e7e7e7; color:#212121; transition-duration: 300ms; box-sizing: border-box; padding:0 2px;}
.list li:nth-of-type(1){border-top:1px solid #e7e7e7;}
.list li .time{flex:0 0 13vw; width:13vw;}
.list li .title{flex:1 1 auto; min-width: 0;}
.list li i{flex:0 0 30px; width:30px; line-height:3.68vw; text-align:right;}
.list li a:hover{color:#f50045; background: #f8f8f8;}


@media (max-width:991px){
.fs16{font-size:2.8vw; line-height:2.8vw;}
.topimg{width:100%; height:20vw; background:url(../../assets/breadcrumb/001.jpg) no-repeat center; background-size:cover;}
.con{padding:6vw 1.5vw;}


.list{margin-top:4vw;}
.list li{height:15vw; line-height:15w; border-bottom:0.5px solid #e7e7e7;}
.list li:nth-of-type(1){border-top:0.5px solid #e7e7e7;}
.list li .time{flex:0 0 19vw; width:19vw;}
.list li .title{display:flex; flex-direction: column; justify-content: center; line-height:4vw;}
.list li .title>span:nth-of-type(1){color:#999; margin-bottom:1vw;}
.list li .title>span:nth-of-type(2){font-size:3.5vw;}

}
</style>


